import { useSelector, useDispatch } from "react-redux";
import { toggleLocationUpdateModal, toggleProfileUpdateModal } from "../../redux-stores/slices/layoutSlice";
import { RootState, AppDispatch } from "../../redux-stores/store";
import ProfileCompletion from "./ProfileCompletion";

const BasicProfile: React.FC = () => {

    const influencer = useSelector((state: RootState) => state.influencer.influencer);


    const dispatch = useDispatch<AppDispatch>();

    const openProfileEditModal = () => {
        dispatch(toggleProfileUpdateModal(true));
    }
    return (
        <div className="d-flex flex-row flex-wrap">
            <div className="d-flex flex-column mb-3">
                <div className="d-flex flex-row align-items-center">
                    {/* <span>
                        <div className="symbol symbol-100px symbol-circle">
                            <img src={influencer?.profile_picture_url} className="rounded-xl" width={100} alt="image" />
                        </div>
                    </span> */}
                    <div className="d-flex ps-3 flex-column">
                        <div className="d-flex align-items-center">
                            <h3 className="font-600 pt-1 mb-n1">{influencer?.name}</h3>
                            <span className="cursor-pointer d-flex align-items-center gap-1 ms-2 mt-2 color-highlight" onClick={openProfileEditModal}> <i className="fa-solid fa-pen"></i> <strong>Edit</strong></span>
                        </div>
                        {
                            influencer?.gender &&
                            <span className="font-weight-bold d-flex align-items-center gap-2 mt-1">
                                {
                                    influencer?.gender === 'M' &&
                                    <i className="fa-solid fa-mars"></i>
                                }
                                {
                                    influencer?.gender == 'F' &&
                                    <i className="fa-solid fa-venus"></i>
                                }
                                <strong>{influencer?.gender_name}</strong>
                            </span>
                        }

                        {
                            influencer?.age &&
                            <span className="font-weight-bold d-flex align-items-center gap-2"><i className="fa-solid fa-cake-candles"></i> <strong>{influencer?.age}</strong></span>
                        }
                        <span className="d-flex align-items-center gap-2"><i className="fa-solid fa-map-marker-alt"></i> <strong>{(influencer?.location) ?? <i className="text-muted fw-normal"> Not Available</i> }</strong> <span className="cursor-pointer d-flex align-items-center gap-1" style={{marginBottom: '4px'}} onClick={() => dispatch(toggleLocationUpdateModal(true))}> <i className="fa-solid fa-pen"></i> </span></span>
                    </div>
                </div>
                {/* {
                    influencer?.niches && influencer.niches.length > 0 &&
                    <div className="mt-3 d-flex flex-column">
                        <small className="d-inline-block text-muted">Areas of Influence</small>
                        <span className="d-flex flex-row flex-wrap">
                            {
                                influencer?.niche_names?.map((niche, i) => {
                                    return (
                                        <span key={i} className="border rounded-pill border-gray-300 mt-2 me-2 py-75 px-2 font-12" >{niche}</span>
                                    )
                                })
                            }
                        </span>
                    </div>
                } */}
            </div>
            {
                influencer?.profile_completion !== 100 &&
                <div className="d-flex justify-content-center w-100">
                    <ProfileCompletion />
                </div>
            }
        </div>
    )
}

export default BasicProfile